import 'url-search-params-polyfill';
import { createSymbiote } from 'redux-symbiote';
import { POP_CURRENT_TEAM } from '@constants';
import { ls } from '@lib/local-storage';

const url = new URLSearchParams(window.location.search);

const initialState = {
  username: '',
  avatar: '',
  tariff: {
    name: '',
    alias: '',
    expire: 0,
    options: [],
  },
  currencyCode: '',
  teams: [],
  goods: [],
  products: [],
  allPricing: [],
  about: '',
  email: '',
  origEmail: '',
  hasPassword: window._user && window._user.hasPassword,
  id: window._user && window._user.id,
  currentTeam: window._user && getCurrentTeamId(window._user.id),
  workMode: 'SOLO',
  options: {
    renderList: 0,
    allowImportProjects: 0,
  },
  fetching: {
    status: null,
    progress: null,
  },
  processing: false, // изменяется вручную
  fbAuth: window._user && window._user.fbAuth,
  vkAuth: window._user && window._user.vkAuth,
  googleAuth: window._user && window._user.googleAuth,
  userUpdate: 0,
  goodsUpdate: 0,
  teamsUpdate: 0,
  initiated: false,
  locale: '',
  cards: '', // не понятно как отображать уведомление если пустой массив
  paymentMethods: '',
  countries: '',
  autopayment: '',
  linked_accounts: {
    vkontakte: '',
    facebook: '',
    google: '',
  },
  languages: {
    current: {},
    list: {},
  },
};

export const { actions, reducer } = createSymbiote(
  initialState,
  {
    setUserData: (state, data) => {
      const workMode = getTeamRole(state.currentTeam, state.teams, data.id);

      return {
        ...state,
        ...data,
        workMode,
        currentTeam: getCurrentTeamId(state.id),
        userUpdate: Date.now(),
      };
    },
    setGoods: (state, data) => {
      return {
        ...state,
        ...data,
        tariff: {
          ...state.tariff,
          ...data.tariff,
        },
        goodsUpdate: Date.now(),
      };
    },
    setTeams: (state, data) => {
      const workMode = getTeamRole(state.currentTeam, data.teams, state.id);
      const currentTeamFull = data.teams.find((item) => item.id === state.currentTeam);
      return {
        ...state,
        ...data,
        workMode,
        currentTeamFull,
        teamsUpdate: Date.now(),
      };
    },
    setCurrentTeam: (state, value) => {
      const workMode = getTeamRole(value, state.teams, state.id);
      const currentTeamFull = state.teams.find((item) => item.id === value);

      ls.setItem(state.id + '.currentTeam', value);
      ls.setItem(POP_CURRENT_TEAM, value);

      url.delete('team_id');
      window.history.pushState(null, null, `?${url.toString()}`);

      return {
        ...state,
        workMode,
        currentTeam: value,
        currentTeamFull,
      };
    },
    setProducts: (state, data) => ({
      ...state,
      products: data,
    }),
    setAllPricing: (state, data) => ({
      ...state,
      allPricing: data,
    }),
    fetching: {
      start: (state) => ({
        ...state,
        fetching: { ...state.fetching, status: 'fetching' },
      }),
      end: (state) => ({
        ...state,
        fetching: { ...state.fetching, status: null },
      }),
      fail: (state) => ({
        ...state,
        fetching: { ...state.fetching, status: null },
      }),
    },
    setVkAuth: (state, data) => ({
      ...state,
      vkAuth: data,
    }),
    setFbAuth: (state, data) => ({
      ...state,
      fbAuth: data,
    }),
    setGoogleAuth: (state, data) => ({
      ...state,
      googleAuth: data,
    }),
    setSocialName: (state, data) => ({
      ...state,
      linked_accounts: {
        ...state.linked_accounts,
        ...data,
      },
    }),
    setHasPassword: (state, data) => ({
      ...state,
      hasPassowrd: data,
    }),
    setLastUpdate: (state, field, time) => ({
      ...state,
      [field]: time ? time : Date.now(),
    }),
    setInit: (state, init) => ({
      ...state,
      initiated: init,
    }),
    setLocale: (state, lang) => ({
      ...state,
      locale: lang,
    }),
    setCards: (state, data) => ({
      ...state,
      cards: data,
    }),
    setPaymentMethods: (state, data) => ({
      ...state,
      paymentMethods: data,
    }),
    setCountries: (state, data) => {
      return {
        ...state,
        countries: data,
      };
    },
    setAutoPayStatus: (state, data) => ({
      ...state,
      autopayment: data,
    }),
    setProcessing: (state, data) => ({
      ...state,
      processing: data,
    }),
    setLanguages: (state, data) => ({
      ...state,
      languages: {
        current: data.current,
        list: data.list,
      },
    }),
  },
  'common'
);

export function getTeamRole(teamId, teams, userId) {
  let workMode = 'SOLO';

  if (teamId) {
    const team = teams.find((item) => item.id === teamId);

    if (team) {
      workMode = team.usersId === userId ? 'TEAM_FOUNDER' : 'TEAM_MEMBER';
    }
  }

  return workMode;
}

function getCurrentTeamId(id) {
  const team_id = url.get('team_id');
  const oldLSCurrentTeam = parseInt(ls.getItem(id + '.currentTeam'));
  const newLSCurrentTeam = parseInt(ls.getItem(POP_CURRENT_TEAM));

  return team_id ? Number(team_id) : newLSCurrentTeam || oldLSCurrentTeam || null;
}

export const reducers = {
  common: reducer,
};
